import { create } from 'zustand'

export const useAuthStore = create((set) => ({
  currentUser: null,
  currentUserId: null,
  signInSuccess: ({ token, user }) =>
    set({ currentUser: token, currentUserId: user }),
  signOut: () => set({ currentUser: null, currentUserId: null }),
}))
